module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-details"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.tab1href,
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.t('Price comparison')) + "\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      'disabled': !_vm.count_allegro
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.tab5href,
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.t('Allegro')) + "\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      'disabled': !_vm.count_ceneo
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.tab9href,
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.t('Ceneo')) + "\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      'disabled': !_vm.count_amazon
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.tab19href,
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.t('Amazon')) + "\n            ")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.tab4href,
      "role": "tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.loadPriceHistory()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.t('History of prices')) + "\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      'disabled': !_vm.count_ceneo
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.tab10href,
      "role": "tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.loadPriceHistoryCeneo()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.t('History of prices')) + " - Ceneo\n            ")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.tab7href,
      "role": "tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.loadPriceHistoryHour()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.t('Hourly price history')) + "\n            ")])]), _vm._v(" "), (_vm.$data.showSimilar) ? _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.tab6href,
      "role": "tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.loadSimilar()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.t('Similar')) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.tab20href,
      "role": "tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.loadWhoFirstDropPrice()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.t('Who drop the price first')) + "\n            ")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.tab23href,
      "role": "tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.loadSimilar()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.t('Similar products')) + "\n            ")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": 'product-history/' + _vm.$data.id,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-stats"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab1ID
    }
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "60px"
    }
  }, [_vm._v(_vm._s(_vm.t('Active')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Shop')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Product')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Producer code')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Price')))])]), _vm._v(" "), _vm._l((_vm.offers), function(offer) {
    return _c('tr', {
      staticClass: "offers"
    }, [_c('td', {
      class: {
        'active': offer.active, 'inactive': !offer.active
      }
    }, [(offer.active) ? _c('span', [_vm._v("+")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(offer.shop_name))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": offer.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(offer.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(offer.codes))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(offer.current_price))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab5ID
    }
  }, [(_vm.count_allegro) ? _c('div', [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.t('Product')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Seller')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Price')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Views')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Sale')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Featured')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Highlighted')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Bold')))]), _vm._v(" "), _c('th', [_vm._v("+ " + _vm._s(_vm.t('Categories')))]), _vm._v(" "), _c('th', [_vm._v("+ " + _vm._s(_vm.t('Homepage')))])]), _vm._v(" "), _vm._l((_vm.allegro), function(all) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": all.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(all.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(all.seller))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(all.current_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(all.views))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(all.quantity_sold))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(all.promoted_by_featured) ? _c('span', {
      staticClass: "glyphicon glyphicon-ok text-success"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(all.promoted_by_highlight) ? _c('span', {
      staticClass: "glyphicon glyphicon-ok text-success"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(all.promoted_by_bold) ? _c('span', {
      staticClass: "glyphicon glyphicon-ok text-success"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(all.promoted_in_categories) ? _c('span', {
      staticClass: "glyphicon glyphicon-ok text-success"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(all.promoted_in_homepage) ? _c('span', {
      staticClass: "glyphicon glyphicon-ok text-success"
    }) : _vm._e()])])
  })], 2)]) : _c('div', [_vm._v("\n                " + _vm._s(_vm.t('The tab is not available for this product')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab9ID
    }
  }, [(_vm.count_ceneo) ? _c('div', [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.t('Product')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Seller')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Price')))])]), _vm._v(" "), _vm._l((_vm.ceneo), function(all) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": all.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(all.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(all.seller))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(all.current_price))])])
  })], 2)]) : _c('div', [_vm._v("\n                " + _vm._s(_vm.t('The tab is not available for this product')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab19ID
    }
  }, [(_vm.count_amazon) ? _c('div', _vm._l((_vm.amazon), function(a) {
    return _c('div', [_c('strong', [_vm._v(_vm._s(a.name))]), _vm._v(" "), _c('table', {
      staticClass: "table table-condensed"
    }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.t('Product')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Price')))])]), _vm._v(" "), _vm._l((a.list), function(all) {
      return _c('tr', [_c('td', [_c('a', {
        attrs: {
          "href": all.link,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(all.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(all.current_price))])])
    })], 2)])
  }), 0) : _c('div', [_vm._v("\n                " + _vm._s(_vm.t('The tab is not available for this product')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab8ID
    }
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.t('Product')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Shop')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Seller')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Price')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Views')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Sale')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Featured')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Highlighted')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Bold')))]), _vm._v(" "), _c('th', [_vm._v("+ " + _vm._s(_vm.t('Categories')))]), _vm._v(" "), _c('th', [_vm._v("+ " + _vm._s(_vm.t('Homepage')))])]), _vm._v(" "), _vm._l((_vm.mapped_allegro), function(all) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": all.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(all.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(all.shop))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(all.seller))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(all.current_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(all.views))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(all.quantity_sold))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(all.promoted_by_featured) ? _c('span', {
      staticClass: "glyphicon glyphicon-ok text-success"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(all.promoted_by_highlight) ? _c('span', {
      staticClass: "glyphicon glyphicon-ok text-success"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(all.promoted_by_bold) ? _c('span', {
      staticClass: "glyphicon glyphicon-ok text-success"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(all.promoted_in_categories) ? _c('span', {
      staticClass: "glyphicon glyphicon-ok text-success"
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(all.promoted_in_homepage) ? _c('span', {
      staticClass: "glyphicon glyphicon-ok text-success"
    }) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab2ID
    }
  }, [_vm._v("\n            " + _vm._s(_vm.t('Price management')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab3ID
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane price-history",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab4ID
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane price-history-ceneo",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab10ID
    }
  }, [(_vm.count_ceneo) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.priceHistoryCeneo.loading),
      expression: "priceHistoryCeneo.loading"
    }],
    staticClass: "loading-fragment"
  }, [_c('div', {
    staticClass: "dataTables_processing panel panel-default"
  }, [_vm._v(_vm._s(_vm.t('Processing')) + "...")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.priceHistoryCeneo.loading),
      expression: "!priceHistoryCeneo.loading"
    }]
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.priceHistoryCeneo.chartOpened = !_vm.priceHistoryCeneo.chartOpened
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Fullscreen')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('default-chart', {
    attrs: {
      "labels": _vm.priceHistoryCeneo.labels,
      "items": _vm.priceHistoryCeneo.items,
      "height": 75,
      "options": {
        responsive: true,
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: false
            }
          }]
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fullscreen-chart",
    class: {
      'opened': _vm.priceHistoryCeneo.chartOpened
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.priceHistoryCeneo.loading),
      expression: "priceHistoryCeneo.loading"
    }],
    staticClass: "loading-fragment"
  }, [_c('div', {
    staticClass: "dataTables_processing panel panel-default"
  }, [_vm._v(_vm._s(_vm.t('Processing')) + "...")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.priceHistoryCeneo.loading),
      expression: "!priceHistoryCeneo.loading"
    }]
  }, [_c('datepicker', {
    ref: "fromDate",
    staticStyle: {
      "margin": "auto",
      "text-align": "center"
    },
    attrs: {
      "name": "from",
      "placeholder": _vm.datePicker.placeholder,
      "language": _vm.datePicker.language,
      "monday-first": true,
      "format": _vm.datePicker.dateFormat,
      "disabled": _vm.datePicker.disabled,
      "disabled-picker": _vm.datePicker.disabledPicker,
      "calendar-button": true,
      "clear-button-icon": "glyphicon glyphicon-remove",
      "calendar-button-icon": "glyphicon glyphicon-time"
    },
    on: {
      "input": _vm.priceHistoryCeneoChange
    },
    model: {
      value: (_vm.priceHistoryCeneo.date),
      callback: function($$v) {
        _vm.$set(_vm.priceHistoryCeneo, "date", $$v)
      },
      expression: "priceHistoryCeneo.date"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.priceHistoryCeneo.chartOpened = !_vm.priceHistoryCeneo.chartOpened
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Hide')))])]), _vm._v(" "), _c('default-chart', {
    attrs: {
      "labels": _vm.priceHistoryCeneo.labels,
      "items": _vm.priceHistoryCeneo.items,
      "height": 135,
      "options": {
        responsive: true,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: false,
            }
          }]
        }
      }
    }
  })], 1)])], 1)]) : _c('div', [_vm._v("\n                " + _vm._s(_vm.t('The tab is not available for this product')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane price-history-hour",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab7ID
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.priceHistoryHour.loading),
      expression: "priceHistoryHour.loading"
    }],
    staticClass: "loading-fragment"
  }, [_c('div', {
    staticClass: "dataTables_processing panel panel-default"
  }, [_vm._v(_vm._s(_vm.t('Processing')) + "...")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.priceHistoryHour.loading),
      expression: "!priceHistoryHour.loading"
    }]
  }, [_c('datepicker', {
    ref: "fromDate",
    attrs: {
      "name": "from",
      "placeholder": _vm.datePicker.placeholder,
      "language": _vm.datePicker.language,
      "monday-first": true,
      "format": _vm.datePicker.dateFormat,
      "disabled": _vm.datePicker.disabled,
      "disabled-picker": _vm.datePicker.disabledPicker,
      "calendar-button": true,
      "clear-button-icon": "glyphicon glyphicon-remove",
      "calendar-button-icon": "glyphicon glyphicon-time"
    },
    on: {
      "input": _vm.priceHistoryHourChange
    },
    model: {
      value: (_vm.priceHistoryHour.date),
      callback: function($$v) {
        _vm.$set(_vm.priceHistoryHour, "date", $$v)
      },
      expression: "priceHistoryHour.date"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('default-chart', {
    attrs: {
      "labels": _vm.priceHistoryHour.labels,
      "items": _vm.priceHistoryHour.items,
      "height": 75
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane price-history-with-ceneo",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab21ID
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane similar-products",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab6ID
    }
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab20ID
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.whoFirstDropPrice.loading),
      expression: "this.whoFirstDropPrice.loading"
    }],
    staticClass: "loading-fragment"
  }, [_c('div', {
    staticClass: "dataTables_processing panel panel-default"
  }, [_vm._v(_vm._s(_vm.t('Processing')) + "...")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.whoFirstDropPrice.loading),
      expression: "!this.whoFirstDropPrice.loading"
    }]
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.whoFirstDropPriceSearch($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "srp"
    }
  }, [_vm._v(_vm._s(_vm.t('SRP price')) + ": ")]), _vm._v(" "), _c('money', {
    attrs: {
      "id": "srp"
    },
    model: {
      value: (_vm.whoFirstDropPrice.price),
      callback: function($$v) {
        _vm.$set(_vm.whoFirstDropPrice, "price", $$v)
      },
      expression: "whoFirstDropPrice.price"
    }
  }), _vm._v(" "), _c('date-range-picker', {
    model: {
      value: (_vm.whoFirstDropPrice.date),
      callback: function($$v) {
        _vm.$set(_vm.whoFirstDropPrice, "date", $$v)
      },
      expression: "whoFirstDropPrice.date"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-confirm"
  }, [_vm._v(_vm._s(_vm.t('Search')))])], 1), _vm._v(" "), (_vm.whoFirstDropPrice.items.length > 0) ? _c('table', {
    staticClass: "table table-condensed"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.t('Shop')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Price')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Date')))])]), _vm._v(" "), _vm._l((_vm.whoFirstDropPrice.items), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.shop))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))])])
  })], 2) : _c('div', [_vm._v(_vm._s(_vm.t('Not found')) + ".")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane merge-history",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab22ID
    }
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading-fragment"
  }, [_c('div', {
    staticClass: "dataTables_processing panel panel-default"
  }, [_vm._v("\n                        " + _vm._s(_vm.t('Processing')) + "...\n                    ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [(!_vm.mergeHistory.length) ? _c('div', [_vm._v("\n                        " + _vm._s(_vm.t('No data')) + "\n                    ")]) : _c('div', [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "170px"
    }
  }, [_vm._v(_vm._s(_vm.t('Shop')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Product')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.mergeHistory), function(item) {
    return _c('tr', [_c('td', [(item.added) ? _c('span', {
      staticClass: "text-success glyphicon glyphicon-plus"
    }) : (item.removed) ? _c('span', {
      staticClass: "text-danger glyphicon glyphicon-minus"
    }) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(item.shop_name) + "\n                                        "), (item.seller_name) ? _c('span', [_vm._v(" - " + _vm._s(item.seller_name))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": item.link,
        "taget": "_blank"
      }
    }, [_vm._v(_vm._s(item.name))])])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane similar",
    attrs: {
      "role": "tabpanel",
      "id": _vm.tab23ID
    }
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading-fragment"
  }, [_c('div', {
    staticClass: "dataTables_processing panel panel-default"
  }, [_vm._v("\n                        " + _vm._s(_vm.t('Processing')) + "...\n                    ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.similarOtherBrand),
      expression: "similarOtherBrand"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.similarOtherBrand) ? _vm._i(_vm.similarOtherBrand, null) > -1 : (_vm.similarOtherBrand)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.similarOtherBrand,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.similarOtherBrand = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.similarOtherBrand = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.similarOtherBrand = $$c
        }
      }, function($event) {
        return _vm.loadSimilar()
      }]
    }
  }), _vm._v(" " + _vm._s(_vm.t('Other brand')) + "\n                    ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.t('Product')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Brand')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Shop')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.t('Price')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.similar), function(item) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.brand_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(item.price)) + " "), _c('small', [_vm._v(_vm._s(item.diff) + "%")])])])
  }), 0)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cf0e4d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDetails.vue
// module id = 1255
// module chunks = 2